// if the value is an object of the shape { en: 'string', nl: 'string' } it gets
// the value of the key that matches the locale. Otherwise it returns the input
// value
export const getLocalizedValue = (value, locale) => {
  if (typeof value === 'object') {
    return value[locale]
  } else {
    return value
  }
}

// Use this to assign a localized value to a previous value that may not have
// been localized before
export const setLocalizedValue = (oldValue, newValue, locale) => {
  if (typeof oldValue === 'object') {
    // If the old value was an object it means it was localized before, we just
    // expand it and override the value for the current locale
    return { ...oldValue, [locale]: newValue }
  } else {
    // If the old value is not an object it was not localized. We copy the value
    // to both dutch and english locale and override it for the current locale
    return { nl: oldValue, en: oldValue, [locale]: newValue }
  }
}
